export default __webpack_public_path__ + "pdf.worker.min-7d9e918cf111b79372d7fd42f57497cf.js";